import client from "./client";

const notificationsApi = {
  list(params = {}) {
    return client.get("/notifications", { params }).then((r) => r.data);
  },

  markRead(id) {
    return client.patch(`/notifications/${id}/read`).then((r) => r.data);
  },

  subscribePush(subscription) {
    return client.post("/notifications/push/subscribe", { subscription }).then((r) => r.data);
  },
};

export default notificationsApi;
